// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./dev/stylist_parent/components/responsive-controls/index.scss
// module id = 1080
// module chunks = 0